<ul class="benefits">
	<li class="benefits__item" *ngFor="let benefit of sortedBenefits">
		<mat-icon
			svgIcon="porto-bank-icons:check"
			style="width: 11px; height: 8px; margin-right: 8px"
		></mat-icon>
		@if (benefit.type === 'discount') {
			<span class="benefits__text" *ngIf="benefit.type === 'discount'">{{ benefit.value }} de </span>
			<span class="benefits__text">{{ benefit.name | lowercase }}</span>
		} @else {
			<span class="benefits__text">{{ benefit.name }}</span>
		}
	</li>
</ul>
